import { ArrayElement } from '../../shared/types'
import { GetZonesQuery, useGetZonesQuery } from '../graphql/queries/getZones.types'
import { useCallback, useMemo } from 'react'

// Temporary API type
type TAPIZone = ArrayElement<GetZonesQuery['getLabels']>
type TAPIUnit = ArrayElement<GetZonesQuery['getLabels']>['units'][0]

type TUnit = {
  id: number
  name: string
  alias: string
}

export type TZone = {
  id: number
  name: string
  alias: string
  countryCodes: string[]
  units: TUnit[]
}

function unitAdapter(apiUnit: TAPIUnit): TUnit {
  return {
    id: parseInt(apiUnit.id),
    name: apiUnit.name,
    alias: apiUnit.alias
  }
}

function zoneAdapter(apiZone: TAPIZone): TZone {
  return {
    id: parseInt(apiZone.id),
    name: apiZone.name,
    alias: apiZone.alias,
    countryCodes: apiZone.country_codes ? apiZone.country_codes : [],
    units: apiZone.units?.map(unitAdapter) ?? []
  }
}

export function useZones() {
  const { data: zoneListResponse, loading: zonesLoading, error: zonesError } = useGetZonesQuery()
  const zonesMap = useMemo(() => {
    const map = new Map<number, TZone>()

    if (Array.isArray(zoneListResponse?.getLabels)) {
      zoneListResponse?.getLabels.forEach((apiZone) => {
        const zone = zoneAdapter(apiZone)
        map.set(zone.id, zone)
      })
    }
    return map

  }, [zoneListResponse?.getLabels])

  const getZoneById = useCallback((id: number) => {
    return zonesMap.get(id)
  }, [zonesMap])

  const getZoneByAlias = useCallback((alias?: string) => {
    if(!alias) return undefined
    for (const zone of zonesMap.values()) {
      if (zone.alias === alias) {
        return zone
      }
    }
  }, [zonesMap])

  return {
    zonesMap,
    getZoneById,
    getZoneByAlias,
    zonesLoading,
    zonesError
  }
}
